import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import guardImage from "../assets/guardremote.jpg";
import guardImage2 from "../assets/guardsee.jpg";
import guardImage3 from "../assets/nameplateguard.jpg";
import guardImage4 from "../assets/midcompsee.jpg";
import guardImage5 from "../assets/backcompsee.jpg";
import guardImage6 from "../assets/compseeguard.jpg";
import guardImage8 from "../assets/guardnameplate.jpg";

function Services() {

  const services = [
  {
    title: "On-Site Security Guards",
    desc: "Our highly trained on-site security guards provide constant monitoring and protection for commercial, residential, and construction sites. They ensure safety through proactive surveillance, risk assessment, and detailed reporting, creating a secure environment for your property and personnel.",
    image: guardImage,
  },
  {
    title: "Mobile Patrol Services",
    desc: "LineGuard Security offers flexible mobile patrol services to monitor multiple locations efficiently. Our patrol officers conduct scheduled and random checks to deter criminal activity, respond to incidents promptly, and maintain comprehensive records to enhance security operations.",
    image: guardImage2,
  },
  {
    title: "Event Security",
    desc: "We provide professional event security to ensure the safety of guests, staff, and assets during public or private events. Our services include crowd management, access control, risk assessment, and emergency response planning to create a seamless and secure event experience.",
    image: guardImage3,
  },
  {
    title: "Concierge Security Services",
    desc: "Our concierge security personnel offer a unique blend of customer service and security expertise. Positioned at entry points, they manage visitor access, monitor lobbies, and provide assistance while maintaining a safe and professional environment for employees and residents.",
    image: guardImage4,
  },
  {
    title: "Alarm Response Services",
    desc: "We provide rapid and reliable alarm response services, ensuring immediate action in case of security breaches or emergency alerts. Our trained officers assess the situation, inspect the site, and take necessary measures to minimize risks, damage, and potential threats.",
    image: guardImage5,
  },
  {
    title: "Customized Security Solutions",
    desc: "LineGuard Security creates personalized security strategies tailored to the unique needs of each client. Whether for corporate offices, residential complexes, or industrial facilities, our customized solutions combine risk assessment, trained personnel, and technology to deliver effective and reliable protection.",
    image: guardImage6,
  },
];


  return (
    <Box sx={{ p: {  md: 6 } }}>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "300px", md: "500px" },
          backgroundImage: `url(${guardImage8})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
          padding: 0,
        }}
      >
        <Box
          sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.6)" }}
        />
        <Box sx={{ position: "relative", zIndex: 1, px: 2 }}>
          <Typography variant="h2" sx={{ fontWeight: "bold", mb: 2 }}>
            Our Services
          </Typography>
        </Box>
      </Box>

      {/* Services Zig-Zag Layout */}
      <Box sx={{ mt: 6 }}>
        {services.map((service, index) => {
          const isEven = index % 2 === 0;
          return (
            <Grid
              container
              spacing={4}
              alignItems="center"
              key={index}
              direction={{ xs: "column", md: isEven ? "row" : "row-reverse" }}
              sx={{ mb: 8 }}
            >
              {/* Image */}
              <Grid item xs={12} md={6}>
                <Box
                  component="img"
                  src={service.image}
                  alt={service.title}
                  sx={{
                    width: "100%",
                    borderRadius: 3,
                    boxShadow: 3,
                    objectFit: "cover",
                    height: { xs: "250px", md: "350px" },
                  }}
                />
              </Grid>

              {/* Text */}
              <Grid item xs={12} md={6}>
                <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2 }}>
                  {service.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {service.desc}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Box>
    </Box>
  );
}

export default Services;
